import React from 'react';
import PropTypes from 'prop-types';

const ProductsStock = ({ availableItemLength, itemsLength, stockLabel }) => (
  <span>
    <span className="value">
      {availableItemLength} / {itemsLength}
    </span>{' '}
    {stockLabel}
  </span>
);

ProductsStock.propTypes = {
  availableItemLength: PropTypes.number,
  itemsLength: PropTypes.number,
  stockLabel: PropTypes.string,
};

export default ProductsStock;
